import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { SchemaContext, SchemaProvider } from '../../providers/SchemaProvider';
import { AutoField } from '../AutoField';
export const AllOfField = ({ propName, required, onRemove }) => {
    const { schema } = useContext(SchemaContext);
    if (!Array.isArray(schema.allOf)) {
        throw new Error('AllOfField: allOf must be an array');
    }
    return (_jsx(_Fragment, { children: schema.allOf.map((schema, index) => {
            return (_jsx(SchemaProvider, { schema: schema, children: _jsx(AutoField, { propName: propName, required: required, onRemove: onRemove }) }, index));
        }) }));
};
//# sourceMappingURL=AllOfField.js.map